import { render, staticRenderFns } from "./ingredient.vue?vue&type=template&id=37553db5&scoped=true&"
import script from "./ingredient.vue?vue&type=script&lang=js&"
export * from "./ingredient.vue?vue&type=script&lang=js&"
import style0 from "./ingredient.vue?vue&type=style&index=0&id=37553db5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37553db5",
  null
  
)

export default component.exports